export enum VerizonLoginKeys {
    USERNAME = "username",
    PASSWORD = "password",
}